module.exports = __webpack_public_path__ + "static/media/syncrophi.2d9ee5dc.jpg";